import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function BlogBreadcrumb({ title }: { title: string }) {
  const { t } = useTranslation();
  return (
    <nav
      aria-label={t('blog.breadcrumb')}
      className="mx-auto w-full max-w-[1200px] px-4 pt-4 sm:px-6 lg:px-6 lg:pt-4"
    >
      <ol className="flex flex-wrap items-center gap-2 text-[10px] font-medium leading-[1.2] lg:text-[12px]">
        <li className="flex items-center gap-2">
          <Link
            className="text-secondary-400 transition-colors hover:text-secondary-900"
            to="/"
          >
            {t('blog.home')}
          </Link>
        </li>
        <li className="flex items-center gap-2">
          <Link
            className="text-secondary-400 transition-colors hover:text-secondary-900"
            to="/blog"
          >
            {t('blog.blog')}
          </Link>
        </li>
        <li className="flex items-center gap-2">
          <span
            className="line-clamp-1 max-w-[320px] text-secondary-900 lg:max-w-[600px]"
            aria-current="page"
          >
            {title}
          </span>
        </li>
      </ol>
    </nav>
  );
}